import React from "react";
import WidgetSkeleton from "../widget/WidgetSkeleton";

type Props = {
  topCustomer: any | null;
  isLoadingTopCustomer: boolean;
};
const Section10 = ({ topCustomer, isLoadingTopCustomer }: Props) => {
  const data = Array.isArray(topCustomer?.data) ? topCustomer.data : [];
  const summary = topCustomer?.summary || {};

  const monthKeys: string[] = data[0]
    ? Object.keys(data[0].revenue)
    : ["Jan", "Feb", "Mar"];

  return (
    <div className="row">
      <div className="mb-2 col-12 col-sm-12 col-md-12 col-lg-7">
        <div className="card bg-white p-4" style={{ position: "relative" }}>
          {isLoadingTopCustomer && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "white",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WidgetSkeleton />
            </div>
          )}
          <div className="row mb-2">
            <div className="col-12">
              <div className="flex justify-between">
                <span className="text-black text-sm text-md-base">
                  PROFILE TOP 25 CUSTOMER (VOLUME & SLA PERFORMANCE)
                </span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="table-responsive">
                <table className="table table-sm" style={{ fontSize: "12px" }}>
                  <thead>
                    <tr>
                      <th
                        rowSpan={2}
                        style={{
                          backgroundColor: "#2a363c",
                          color: "white",
                          borderRadius: "10px 0 0 10px",
                          width: "4%",
                        }}
                      >
                        No.
                      </th>
                      <th
                        rowSpan={2}
                        style={{
                          backgroundColor: "#2a363c",
                          color: "white",
                          textAlign: "left",
                          paddingLeft: "10px",
                          borderRadius: "0px 10px 10px 0px",
                          width: "36%",
                        }}
                      >
                        Nama Pelanggan
                      </th>
                      <th
                        className="text-center"
                        style={{
                          backgroundColor: "#99b898",
                          color: "white",
                          borderRadius: "10px 10px 0px 0px",
                          borderBottom: "none",
                          width: "10%",
                        }}
                      >
                        Airwaybill
                      </th>
                      <th
                        className="text-center"
                        style={{
                          backgroundColor: "#5b7763",
                          color: "white",
                          borderRadius: "10px 10px 0px 0px",
                          borderBottom: "none",
                          width: "10%",
                        }}
                      >
                        Volume
                      </th>
                      <th
                        colSpan={3}
                        className="text-center"
                        style={{
                          backgroundColor: "#b38957",
                          color: "white",
                          borderRadius: "10px 10px 0px 0px",
                          borderBottom: "none",
                          width: "20%",
                        }}
                      >
                        Performance SLA (%)
                      </th>
                    </tr>
                    <tr>
                      <th
                        className="text-center"
                        style={{
                          backgroundColor: "#99b898",
                          color: "white",
                          borderRadius: "0px 0px 10px 10px",
                          borderTop: "none",
                        }}
                      >
                        Pieces
                      </th>
                      <th
                        className="text-center"
                        style={{
                          backgroundColor: "#5b7763",
                          color: "white",
                          borderRadius: "0px 0px 10px 10px",
                          borderTop: "none",
                        }}
                      >
                        Tonnage
                      </th>
                      {monthKeys.map((month, idx) => (
                        <th
                          key={`sla-head-${month}`}
                          className="text-center"
                          style={{
                            backgroundColor: "#b38957",
                            color: "white",
                            borderRadius:
                              idx === 0
                                ? "0px 0px 0px 10px"
                                : idx === monthKeys.length - 1
                                ? "0px 0px 10px 0px"
                                : "0px",
                            borderTop: "none",
                          }}
                        >
                          {month.toUpperCase()}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {isLoadingTopCustomer ? (
                      <tr>
                        <td colSpan={4 + monthKeys.length}>Loading...</td>
                      </tr>
                    ) : data.length === 0 ? (
                      <tr>
                        <td colSpan={4 + monthKeys.length}>No Data</td>
                      </tr>
                    ) : (
                      data.map((customer: any, idx: number) => (
                        <tr key={idx}>
                          <td>{idx + 1}</td>
                          <td className="text-start">
                            {customer.customer_group_name_cco}
                          </td>
                          <td className="text-center">{customer.awb_no}</td>
                          <td className="text-center">{customer.berat}</td>
                          {monthKeys.map((month) => (
                            <td
                              key={`sla-${idx}-${month}`}
                              className="text-center"
                            >
                              {Number(customer.sla[month] || 0).toFixed(2)}%
                            </td>
                          ))}
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mb-2 col-6 col-sm-6 col-md-6 col-lg-2">
        <div className="card bg-white p-4" style={{ height: 1010 }}>
          {isLoadingTopCustomer && (
            <div
              style={{
                position: "absolute",
                inset: 0,
                background: "white",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <WidgetSkeleton />
            </div>
          )}
          <div style={{ marginBottom: 50 }}>
            <h6 className="text-black">SUMMARY</h6>
            <h6 className="text-black">PROFILE TOP 25</h6>
            <h6 className="text-black">CUSTOMER (VOLUME &</h6>
            <h6 className="text-black">SLA PERFORMANCE)</h6>
          </div>

          <div style={{ marginBottom: 50 }}>
            <h6 className="text-black mb-3">VOLUME</h6>
            {monthKeys.map((month, idx) => (
              <div key={month} className="mb-2">
                <div className="text-black">{month}</div>
                <div>
                  <span className="fw-bold fs-20 text-black">
                    {Number(summary[`berat_${idx + 2}`] || 0).toLocaleString(
                      "id-ID"
                    )}
                  </span>{" "}
                  T
                </div>
              </div>
            ))}
          </div>

          <div style={{ marginBottom: 50 }}>
            <h6 className="text-black mb-3">AVERAGE PERFORMANCE SLA</h6>

            {monthKeys.map((month, idx) => {
              const current = summary[`sla_${idx + 2}`] || 0;
              const prev = summary[`sla_${idx + 1}`] || 0;
              const diff = current - prev;
              const isUp = diff >= 0;

              return (
                <div key={`sla-${month}`} className="mb-2">
                  <div className="text-black">{month}</div>
                  <div className="d-flex align-items-center">
                    {idx >= 0 && (
                      <>
                        {isUp ? (
                          <span style={{ color: "green", fontSize: 20 }}>
                            ▲
                          </span>
                        ) : (
                          <span style={{ color: "red", fontSize: 20 }}>▼</span>
                        )}
                      </>
                    )}
                    <div
                      className="ms-1 px-2 rounded text-white fw-bold"
                      style={{
                        backgroundColor: isUp ? "#28a745" : "#dc3545",
                      }}
                    >
                      {Number(current).toFixed(2)}%
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="mb-2 col-6 col-sm-6 col-md-6 col-lg-3">
        {/* <div className="cards bg-white p-4"> */}
        {/* Content */}
        {/* </div> */}
      </div>
    </div>
  );
};

export default Section10;
